const docsHost = 'https://google-analytics.documentation.coolblue.nl';
const getFeatureDocsUrl = (trigger) => `${docsHost}/#/catalog/features/${trigger.name.split('.')[0]}`;
const getTriggerDocsUrl = (trigger) => `${docsHost}/#/catalog/triggers/${trigger.name.replace('.', '/')}`;
let dispatcher = () => null;
export const onValidationError = (listener) => {
    dispatcher = listener;
};
export const dispatchValidationErrors = (trigger, event, errors) => {
    dispatcher(trigger, event, errors, {
        feature: getFeatureDocsUrl(trigger),
        trigger: getTriggerDocsUrl(trigger),
    });
};
